module.exports = __webpack_public_path__ + "static/media/2030097000.299d1d10.jpg";